import React from 'react'
import {
  CardMedia,
  Avatar,
  Typography,
  Card,
  CardActions,
  CardContent,
  Button,
  CardHeader
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  media: {
    height: 220,
  },
  cardPerfil: {
    minHeight: 460
  },
  descricao: {
    minHeight: 190
  }
});

export default function CardPerfil(props) {
  const classes = useStyles();
  const detalhesPerfil = props.detalhesPerfil;

  const [foto, setFoto] = React.useState("");
  const semFoto = "https://www.kindpng.com/picc/m/1-17545_person-icon-png-customer-image-black-and-white.png"

  let descriptionFormataded = detalhesPerfil.descricaoEmpresa;
  if (descriptionFormataded.length > 320) {
    descriptionFormataded = `${detalhesPerfil.descricaoEmpresa.substr(0, 320)}...`;
  }

  React.useEffect(() => {
    if (detalhesPerfil) {
      setFoto(
        detalhesPerfil.fotoPerfil !== "" ?
          detalhesPerfil.fotoPerfil : semFoto
      )
    }
  }, [detalhesPerfil])

  return (
    <Card className={classes.cardPerfil}>
      <CardMedia
        className={classes.media}
        image={detalhesPerfil.fotoCapa}
      />
      <CardContent className={classes.descricao}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" src={foto} />
          }
          title={detalhesPerfil.nomeEmpresa}
          subheader={`${detalhesPerfil.setorEmpresa} - ${detalhesPerfil.cidadeEmpresa}, ${detalhesPerfil.ufEmpresa}`}
        />
        <Typography variant="body2" color="textSecondary" component="p">
          {descriptionFormataded}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="medium" color="primary" href={'/meus-dados'}>
          Editar Perfil
          </Button>
      </CardActions>
    </Card>
  );
}